// RADAR RESIDENCIAL · ACCESO GARANTIZADO A LOS CASOS ACTIVOS (R5).
// Una persona con caso abierto NUNCA queda fuera de alcance por favoritos, búsqueda, densidad u
// orden: si el filtro la excluye de la rejilla, aparece aquí con su caso PRINCIPAL y navega a
// Central con el alarma_id vigente. El read-model residencial entrega el caso principal por
// persona y `casos_activos`: no se anuncia una lista exhaustiva de casos que el endpoint no da.
import { ArrowUpRight, AlertTriangle } from "lucide-react";
import { acentoPersona } from "@/lib/consolaV3/meta";
import { normPri } from "@/lib/centroV3/data";

export default function CasosActivosTira({ ocultas, onCentral, onFicha }) {
  if (!ocultas || ocultas.length === 0) return null;
  return (
    <section data-testid="radar-res-casos-ocultos"
      className="mb-2 rounded-xl border border-[#FE6A55]/30 bg-[#FE6A55]/[0.06] px-3 py-2">
      <p className="mb-1.5 flex flex-wrap items-center gap-x-2 text-[11px] font-bold uppercase tracking-wider text-[#012472]">
        <AlertTriangle className="h-3.5 w-3.5 text-[#FE6A55]" />
        {ocultas.length} {ocultas.length === 1 ? "persona con caso activo fuera de esta vista" : "personas con caso activo fuera de esta vista"}
        <span className="font-semibold normal-case tracking-normal text-slate-500">
          · siguen accesibles aquí
        </span>
      </p>
      <div className="flex flex-wrap gap-1.5">
        {ocultas.map((t) => {
          const ac = acentoPersona(normPri(t.caso.prioridad));
          return (
            <button key={t.id} type="button" data-testid={`radar-res-caso-oculto-${t.id}`}
              onClick={() => onCentral(t)}
              onContextMenu={(e) => { e.preventDefault(); onFicha(t); }}
              title={`${t.nombre} · ${t.caso.prioridad_label || t.caso.prioridad} · ${t.caso.en_atencion ? "en atención" : "pendiente"}${t.casos_activos > 1 ? ` · ${t.casos_activos} casos activos` : ""} — abrir en Central`}
              className="inline-flex min-h-9 max-w-full items-center gap-1.5 rounded-lg border bg-white px-2 text-[12px] font-bold text-slate-700 transition-colors hover:border-[#01CBE3]"
              style={{ borderColor: `${ac.hex}66` }}>
              <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: ac.hex }} />
              <span className="min-w-0 truncate">{t.nombre}</span>
              <span className="shrink-0 text-[10px] font-extrabold uppercase" style={{ color: ac.hex }}>
                {(t.caso.prioridad_label || t.caso.prioridad || "").toUpperCase()}
                {t.casos_activos > 1 ? ` +${t.casos_activos - 1}` : ""}
              </span>
              <ArrowUpRight className="h-3.5 w-3.5 shrink-0 text-slate-400" />
            </button>
          );
        })}
      </div>
    </section>
  );
}
